import { z } from "zod";

export const environmentSearch = z.object({ env: z.string().max(255).optional() });

export function getDefaultEnvironment<T extends { slug: string }>(environments: readonly T[]) {
  return (
    environments.find((environment) => environment.slug === "main") ??
    [...environments].sort((left, right) => left.slug.localeCompare(right.slug))[0]
  );
}
